import type React from 'react';
import {
    ZONE_TREND_SHAPES,
    type ZoneTrend as Trend,
} from '../../financialPositionMeta';

type ZoneTrendProps = {
    trend: Trend;
    /** Accessible name — the sparkline carries meaning, so it is not decorative. */
    ariaLabel: string;
};

/**
 * The arrow inside a ghosted zone tile: down for Strained, flat for Stable, up
 * for Strong.
 *
 * Raw SVG rather than a HeroUI component because there is no equivalent — this
 * is a drawing, not a control — and no chart library is warranted for four
 * points and an arrowhead. The colour comes from `currentColor`, so the tile's
 * own semantic text class is what tints it.
 */
export const ZoneTrend: React.FC<ZoneTrendProps> = ({ trend, ariaLabel }) => {
    const shape = ZONE_TREND_SHAPES[trend];

    return (
        <svg
            aria-label={ariaLabel}
            className="h-10 w-24"
            fill="none"
            role="img"
            viewBox="0 0 88 40"
        >
            <polyline
                points={shape.line}
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
            />
            <polygon fill="currentColor" points={shape.arrow} />
        </svg>
    );
};
